import React, { useState } from 'react'
import { stringify } from 'qs'
import { graphql } from 'gatsby'
import { X } from 'react-feather'
import { serialize } from 'dom-form-serializer'

import Layout from '../components/Layout'
import Input from '../components/Input'
import Button from '../components/Button'
import ContactInfo from '../components/ContactInfo'
import CategoriesNav from '../components/CategoriesNav'
import './ContactUs.css'
import { supportNav } from '../commons'

export const ContactUsTemplate = ({ fourthWall = true, formTitle }) => {
  const [showPopup, setShowPopup] = useState(false)

  const togglePopup = () => {
    setShowPopup(!showPopup)
  }

  const handleSubmit = e => {
    e.preventDefault()
    // if (disabled) return

    const form = e.target
    const data = serialize(form)
    // setDisabled(true)
    fetch(form.action + '?' + stringify(data), {
      method: 'POST'
    })
      .then(res => {
        if (res.ok) {
          return res
        } else {
          throw new Error('Network error')
        }
      })
      .then(() => {
        form.reset()
        togglePopup()
        // setDisabled(false)
      })
      .catch(err => {
        console.error(err)
        // setAlert(defaultProps.errorMessage)
        // setDisabled(false)
      })
  }

  return (
    <main>
      <section className="Nav--Container container">
        <CategoriesNav
          hire={true}
          portfolio={false}
          indexName="Support"
          indexSlug="support"
          categories={supportNav}
        />
      </section>

      <section className="section">
        <div className="container">
          {showPopup ? (
            <div className="Popup-Overlay">
              <div className="Popup-Background"></div>
              <div className="Popup-Inner taCenter">
                <X class="Popup-Close" onClick={() => togglePopup()} />
                <div className="Popup-Content">
                  <h2>Cant' wait to meet you!</h2>
                  <h4>We’ll get back to you in less than 24 working hours.</h4>
                  <p>
                    This window closes in 10 seconds or you can click here to go
                    back
                  </p>
                </div>
              </div>
            </div>
          ) : null}
          <ContactInfo fourthWall={fourthWall} />
          <form
            className="section TestForm"
            action=""
            data-netlify=""
            name={formTitle}
            netlify-recaptcha=""
            onSubmit={() => handleSubmit()}
          >
            <header className="TestForm--Header">
              <h2>{formTitle}</h2>
            </header>
            <Input
              type="text"
              withLabel={true}
              label="Full Name"
              id="request-name"
              placeholder="Your full name (e.g. Vuai Mapunda)"
            />
            <Input
              type="text"
              withLabel={true}
              label="Company"
              id="request-company"
              placeholder="Name of your company"
            />
            <Input
              type="email"
              withLabel={true}
              label="Email Address"
              id="request-email"
              placeholder="Provide a valid email address (e.g. praise@philemo-nn.com)"
            />
            <Input
              type="text"
              withLabel={true}
              label="Position"
              required={false}
              id="request-position"
              placeholder="What’s your position in the company?"
            />
            <Input
              type="textarea"
              withLabel={true}
              label="Message Content"
              id="request-details"
              placeholder="Ask, and you shall receive"
            />
            <div className="taRight">
              <Button type="submit" text="Submit request" />
            </div>
          </form>
        </div>
      </section>
    </main>
  )
}

const ContactUs = ({ data: { page } }) => (
  <Layout
    meta={page.frontmatter.meta || false}
    title={page.frontmatter.title || false}
  >
    <ContactUsTemplate {...page} {...page.frontmatter} body={page.body} />
  </Layout>
)

export default ContactUs

export const pageQuery = graphql`
  query ContactUsPage($id: String!) {
    page: mdx(id: { eq: $id }) {
      ...Meta
      body
      frontmatter {
        template
        title
        formTitle
        fourthWall
      }
    }
  }
`
